import { render, staticRenderFns } from "./AdiPaiCureDomiciliariTabellaRiepilogativaComponent.vue?vue&type=template&id=8c895cd6"
import script from "./AdiPaiCureDomiciliariTabellaRiepilogativaComponent.vue?vue&type=script&lang=js"
export * from "./AdiPaiCureDomiciliariTabellaRiepilogativaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports